export type Result<T, E> = { status: "ok"; data: T } | { status: "error"; error: E };

export function ok<T>(data: T): Result<T, never> {
    return { status: "ok", data };
}

export function error<E>(error: E): Result<never, E> {
    return { status: "error", error };
}
